var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#252A41;}\n\t.st1{fill:none;}\n\t.st2{fill:#98A2BB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    transform: "translate(-608 -909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_481_1_",
    transform: "translate(608 909)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11,0c6.08,0,11,4.92,11,11s-4.92,11-11,11S0,17.08,0,11S4.92,0,11,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11,0.88c-2.7,0-5.24,1.05-7.16,2.96S0.88,8.3,0.88,11s1.05,5.24,2.96,7.16c1.91,1.91,4.45,2.96,7.16,2.96 s5.24-1.05,7.16-2.96c1.91-1.91,2.96-4.45,2.96-7.16s-1.05-5.24-2.96-7.16C16.24,1.93,13.7,0.88,11,0.88 M11,0 c6.08,0,11,4.92,11,11s-4.92,11-11,11S0,17.08,0,11S4.92,0,11,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_619"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "619.14,923.64 614.72,919.21 615.34,918.59 619.14,922.39 622.95,918.59 623.57,919.21  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptShow);
export default __webpack_public_path__ + "static/media/recrypt_show.f30a96aa.svg";
export { ForwardRef as ReactComponent };